// Hint shown in place of drag affordances when the active sort is not manual
// (Doc 06 §7 / task T18 §1.3): dragging while alphabetical/due-date sorted is
// meaningless, so handles are hidden and this explains how to get them back.
// Styled like the toolbar's muted summary text (kit `.list-toolbar` muted copy).

import type { ReactNode } from "react";
import { vars } from "@pack-it-up/ui-web";

export const DragDisabledHint = (): ReactNode => (
  <p
    style={{
      margin: `0 0 ${vars.space.sm}`,
      fontSize: vars.font.sizeXs,
      color: vars.color.textMuted,
    }}
  >
    Switch to manual sort to drag and reorder.
  </p>
);
